import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { EVEntry, Container } from '@uswitch/ev-core/react';
import { useMeta } from '@uswitch/ev-utils/context/selectors';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var ImageGridItem = function ImageGridItem(_ref) {
  var entry = _ref.entry,
      className = _ref.className,
      columns = _ref.columns,
      backgroundColor = _ref.backgroundColor,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? [121, 337] : _ref$height,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? [4, 'xxs'] : _ref$padding,
      _ref$imageStyles = _ref.imageStyles,
      imageStyles = _ref$imageStyles === void 0 ? {} : _ref$imageStyles;
  return _jsx("div", {
    className: className,
    sx: {
      height: height,
      overflow: 'hidden',
      flexGrow: 1,
      flexBasis: columns.map(columnsToPercent),
      padding: padding,
      boxSizing: 'border-box'
    },
    children: _jsx("div", {
      sx: {
        backgroundColor: backgroundColor,
        height: '100%',
        overflow: 'hidden',
        position: 'relative'
      },
      children: _jsx(EVEntry, _objectSpread(_objectSpread({}, entry), {}, {
        sx: _objectSpread({
          height: 'auto',
          width: 'auto',
          maxHeight: '100%',
          maxWidth: '100%',
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          margin: 'auto'
        }, imageStyles)
      }))
    })
  });
};

var columnsToPercent = function columnsToPercent(number) {
  var fraction = number / 12;
  var percentage = fraction * 100;
  return "".concat(percentage, "%");
};

var defaultItem = {
  columns: [6, 3]
};

var CollectionImageGrid = function CollectionImageGrid(_ref2) {
  var entries = _ref2.entries;
  var collectionImageGridConfig = useMeta(['collectionImageGridConfig'], {});
  var configItems = collectionImageGridConfig[entries.length] || [];
  return _jsx(Container, {
    children: _jsx("div", {
      sx: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'stretch',
        margin: -8
      },
      children: entries.map(function (entry, index) {
        return _jsx(ImageGridItem, _objectSpread({
          entry: entry
        }, configItems[index] || collectionImageGridConfig.default || defaultItem));
      }, this)
    })
  });
};

export default CollectionImageGrid;
//# sourceMappingURL=collection-image-grid.js.map